import {
  ACTIVO_RESTAURANTES,
  CLEAR_ALL,
  GETALL_RESTAURANTES,
  LOADING_GETALL_RESTAURANTES,
  PARAMS_RESTAURANTES,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {},
};

export const restaurantesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_RESTAURANTES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_GETALL_RESTAURANTES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case ACTIVO_RESTAURANTES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_RESTAURANTES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
